import { plainText } from "@/lib/format";
import type { EmbeddedTestimonial } from "@/lib/dto";

/** How many reviews the package Reviews section shows. */
export const REVIEWS_SHOWN = 6;

/** Length of the plain-text excerpt each review card shows. */
export const REVIEW_TEXT_MAX = 1000;

/**
 * Server-side prep for the (client) PackageReviews section: keep only the
 * reviews it renders, with their text already reduced to the plain excerpt
 * it shows. Everything passed to a client component is serialised into the
 * page payload, so sending all reviews + raw HTML only bloated the HTML.
 */
export function pickReviews(
  reviews: EmbeddedTestimonial[] | undefined,
): EmbeddedTestimonial[] {
  return (reviews ?? [])
    .filter((r) => r.content || r.title)
    .slice(0, REVIEWS_SHOWN)
    .map((r) => ({
      id: r.id,
      title: r.title,
      author_name: r.author_name,
      content: r.content ? plainText(r.content, REVIEW_TEXT_MAX) : undefined,
      rating: r.rating,
      avatar: r.avatar,
      gallery: r.gallery,
    }));
}
